const menu = [
  { icon: "dashboard", text: "Dashboard", link: "/" },
  { icon: "building", text: "Development", link: "/development", type: "development" },
  { icon: "building", text: "Community", link: "/community", type: "community" },
  { icon: "building", text: "Master Community", link: "/master-community", type: "masterCommunity" },
  { icon: "building", text: "Assignments", link: "/assignment", type: "assignment" },
  // { icon: "building", text: "New Homes", link: "/new-homes", type: "newHomes" },
  // { heading: "Pre-built Pages" },
  {
    icon: "users",
    text: "Accounts",
    active: false,
    link: "",
    subMenu: [
      { text: "Users", link: "/users", type: "buyer" },
      { text: "Agents", link: "/agents", type: "agent" },
      { text: "Vip Agents", link: "/vip-agents", type: "vipAgent" },
      { text: "Asscoiates", link: "/associates", type: "associate" },
    ],
  },
  // { heading: "Pre-built Pages" },
  {
    icon: "building",
    text: "Company",
    active: false,
    link: "",
    subMenu: [
      { text: "Building Company", link: "/building-company", type: "developer" },
      { text: "Marketing Company", link: "/marketing-company", type: "marketing" },
      { text: "Brokerages", link: "/brokerages", type: "brokerage" },
    ],
  },
  {
    icon: "map-pin",
    text: "Location",
    active: false,
    link: "",
    subMenu: [
      { text: "Country", link: "/location/country", type: "country" },
      { text: "Province", link: "/location/province", type: "province" },
      { text: "City", link: "/location/city", type: "city" },
      { text: "Neighbourhood", link: "/location/neighbourhood", type: "neighbourhood" },
    ],
  },
  {
    icon: "article",
    text: "Blogs",
    active: false,
    link: "",
    subMenu: [
      { text: "All Blogs", link: "/blogs", type: "blogs" },
      { text: "Blog Categories", link: "/blogs/category", type: "blogs" },
      { text: "Blog Tags", link: "/blogs/tags", type: "blogs" },
    ],
  },
  { icon: "coin", text: "Invoices", active: false, link: "/invoices", type: "invoice" },
  { icon: "file-docs", text: "Feedbacks", active: false, link: "/feedbacks", type: "feedback" },
  { icon: "chat-fill", text: "Testimony", active: false, link: "/testimony", type: "testimony" },
  { icon: "file-docs", text: "FAQs", active: false, link: "/faqs", type: "faqs" },
  { icon: "reports", text: "Inventory Report", active: false, link: "/inventory-report", type: "inventory" },
  { icon: "setting", text: "Settings", active: false, link: "/settings", access: ["superadmin"] },
];

export default menu;
